if (!customElements.get('cart-timer')) {
  const STORAGE_KEY = 'cart-timer-end';

  class CartTimer extends HTMLElement {
    connectedCallback() {
      this.tick = this.tick.bind(this);
      this.tick();
      this.interval = setInterval(this.tick, 1000);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }

    // The end time is shared across pages so the countdown keeps running as the shopper browses.
    getEnd() {
      const minutes = Number(this.dataset.minutes) || 10;
      let end = 0;
      try {
        end = Number(localStorage.getItem(STORAGE_KEY)) || 0;
      } catch {}
      if (!end || end <= Date.now()) {
        end = Date.now() + minutes * 60 * 1000;
        try {
          localStorage.setItem(STORAGE_KEY, String(end));
        } catch {}
      }
      return end;
    }

    tick() {
      const remaining = Math.max(0, this.getEnd() - Date.now());
      const totalSeconds = Math.ceil(remaining / 1000);
      const mm = String(Math.floor(totalSeconds / 60)).padStart(2, '0');
      const ss = String(totalSeconds % 60).padStart(2, '0');
      // The drawer re-renders its HTML on cart changes, so look the node up each tick.
      const time = this.querySelector('[data-timer]');
      if (time) time.textContent = `${mm}:${ss}`;
    }
  }

  customElements.define('cart-timer', CartTimer);
}
